import PageNavLayoutCpt from '@/components/page/PageNavLayoutCpt';
export default {
  components: {
    PageNavLayoutCpt
  }
};